// Converts "Some sTRing" to "some-string"
angular.module('pl-shared')
  .filter('kebabCase', function(_) {
    return _.kebabCase.bind(_)
  })
